import { render, staticRenderFns } from "./theEditDetail.vue?vue&type=template&id=53b99cf2&scoped=true"
import script from "./theEditDetail.vue?vue&type=script&lang=js"
export * from "./theEditDetail.vue?vue&type=script&lang=js"
import style0 from "./theEditDetail.vue?vue&type=style&index=0&id=53b99cf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b99cf2",
  null
  
)

export default component.exports